import { useFormik } from "formik";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

// Redux
import {
  setSearchDepartments,
  setSearchBranches,
  setSearchMainProjects,
  setResetSearchInput,
  setIsDrop,
  setIsToken,
  setHasBudgetCurrentYear,
} from "../../../../redux/slices/projects/projectsSlice";
import { setRmkValue } from "../../../../redux/slices/utilsSlice";

const MoreSearchField = ({ showCanvas, closeCanvas, selectedMinistries }) => {
  const dispatch = useDispatch();

  const [showBranchFilter, setShowBranchFilter] = useState(false);

  const [departments, setDepartments] = useState([]);
  const [ministryValues, setMinistryValues] = useState([]);
  const [departmentValues, setDepartmentValues] = useState([]);
  const [branchValues, setBranchValues] = useState([]);
  const [programValues, setProgramValues] = useState([]);
  const [mainProjectOptions, setMainProjectOptions] = useState([]);
  const [mainProjectValues, setMainProjectValues] = useState([]);

  const {
    rmkOptions,
    ministries,
    branches,
    programs,
    mainProjects,
    projects,
    searchMinistries,
    rmkValue,
    user,
    isToken,
    isDrop,
    hasBudgetCurrentYear,
  } = useSelector((state) => ({
    user: state.userReducer.user,
    rmkOptions: state.utilsReducer.dropdownItems.rmkItems,
    ministries: state.utilsReducer.dropdownItems.ministries,
    branches: state.utilsReducer.dropdownItems.branches,
    programs: state.utilsReducer.dropdownItems.programs,
    mainProjects: state.utilsReducer.dropdownItems.mainProjects,
    rmkValue: state.utilsReducer.rmkValue,

    projects: state.projectReducer.projects,

    searchMinistries: state.projectReducer.searchMinistries,
    isToken: state.projectReducer.isToken,
    isDrop: state.projectReducer.isDrop,
    hasBudgetCurrentYear: state.projectReducer.hasBudgetCurrentYear,
  }));

  const isSuperadmin = user?.roles?.includes("superadmin") || false;

  const handleClose = () => {
    closeCanvas();
  };

  const handleSearch = () => {
    const departmentIds = departmentValues.map((item) => item.id);
    const branchIds = branchValues.map((item) => item.id);
    const mainProjectIds = mainProjectValues.map((item) => item.id);
    dispatch(setSearchDepartments(departmentIds));
    dispatch(setSearchMainProjects(mainProjectIds));
    dispatch(setSearchBranches(branchIds));
  };

  const handleResetField = () => {
    setMinistryValues([]);
    setDepartmentValues([]);
    setBranchValues([]);
    dispatch(setResetSearchInput());
  };

  const handleFilterMinistry = (value) => {
    const departmentOptions = value.reduce((acc, ministry) => {
      return acc.concat(ministry.departments);
    }, []);

    setDepartments(departmentOptions);
    setMinistryValues(value);
  };

  const handleFilterDepartment = (value) => {
    const isSelectJKR = value.some((obj) => obj.short_form === "JKR");

    setShowBranchFilter(isSelectJKR);
    setDepartmentValues(value);

    if (!isSelectJKR) {
      setBranchValues([]);
    }
  };

  const handleFilterBranch = (value) => {
    setBranchValues(value);
  };

  const handleFilterMainProject = (value) => {
    setMainProjectValues(value);
  };

  const handleSelectFederalProject = (value) => {
    localStorage.setItem("federalProjects", JSON.stringify(value));
  };

  useEffect(() => {
    if (!isEmpty(ministries)) {
      const departmentItems = ministries.flatMap((item) => item.departments);

      let deptOptions = [];
      let mainPOptions = [];

      if (isEmpty(searchMinistries)) {
        deptOptions = departmentItems;
        mainPOptions = mainProjects;
      } else {
        deptOptions = departmentItems.filter((item) =>
          searchMinistries.includes(item.ministry_code),
        );
        const findPrograms = programs.filter((item) =>
          searchMinistries.includes(item.ministry_code.toString()),
        );

        mainPOptions = mainProjects.filter((item) =>
          findPrograms.map((obj) => obj.id).includes(item.program_id),
        );
      }

      setDepartments(deptOptions);
      setMainProjectOptions(mainPOptions);
    }
  }, [ministries, searchMinistries]);

  return (
    <Offcanvas show={showCanvas} onHide={handleClose} style={{ width: 310 }}>
      <Offcanvas.Body>
        <Offcanvas.Title className='mb-3'>Carian Tambahan</Offcanvas.Title>
        <Form autoComplete='off' noValidate style={{ fontSize: 12 }}>
          <Form.Group className='mb-3'>
            <Form.Label>RMK</Form.Label>
            <Select
              placeholder=''
              className='react-select-container'
              classNamePrefix='react-select'
              options={rmkOptions}
              value={rmkValue}
              onChange={(value) => dispatch(setRmkValue(value))}
              noOptionsMessage={() => "Tiada pilihan"}
            />
          </Form.Group>
          <Form.Group className='mb-3'>
            <Form.Label>Jabatan/Agensi</Form.Label>
            <Select
              placeholder=''
              className='react-select-container'
              classNamePrefix='react-select'
              isMulti
              options={departments}
              value={departmentValues}
              onChange={(value) => handleFilterDepartment(value)}
              noOptionsMessage={() => "Tiada pilihan"}
            />
          </Form.Group>

          {showBranchFilter && (
            <Form.Group className='mb-3'>
              <Form.Label>Cawangan</Form.Label>
              <Select
                placeholder=''
                className='react-select-container'
                classNamePrefix='react-select'
                isMulti
                options={branches}
                value={branchValues}
                onChange={(value) => handleFilterBranch(value)}
                noOptionsMessage={() => "Tiada pilihan"}
              />
            </Form.Group>
          )}

          <Form.Group className='mb-3'>
            <Form.Label>Projek Utama</Form.Label>
            <Select
              placeholder=''
              className='react-select-container'
              classNamePrefix='react-select'
              isMulti
              options={mainProjectOptions}
              value={mainProjectValues}
              onChange={(value) => handleFilterMainProject(value)}
              noOptionsMessage={() => "Tiada pilihan"}
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Senarai Projek</Form.Label>
            <Select
              placeholder='Pilih jenis'
              className='react-select-container'
              classNamePrefix='react-select'
              options={[
                { label: "Projek Aktif", value: null },
                {
                  label: "Projek Ada Peruntukan Tahun Semasa",
                  value: "has_budget_current_year",
                },
                { label: "Projek Token", value: "token" },
                { label: "Projek Gugur", value: "drop" },
              ]}
              value={
                isDrop
                  ? { label: "Projek Gugur", value: "drop" }
                  : isToken
                  ? { label: "Projek Token", value: "token" }
                  : hasBudgetCurrentYear
                  ? {
                      label: "Projek Ada Peruntukan Tahun Semasa",
                      value: "has_budget_current_year",
                    }
                  : { label: "Projek Aktif", value: null }
              }
              onChange={(selected) => {
                if (selected?.value === "drop") {
                  dispatch(setIsDrop(true));
                  dispatch(setIsToken(null));
                  dispatch(setHasBudgetCurrentYear(null));
                } else if (selected?.value === "token") {
                  dispatch(setIsToken(true));
                  dispatch(setIsDrop(null));
                  dispatch(setHasBudgetCurrentYear(null));
                } else if (selected?.value === "has_budget_current_year") {
                  dispatch(setHasBudgetCurrentYear(true));
                  dispatch(setIsDrop(null));
                  dispatch(setIsToken(null));
                } else {
                  dispatch(setIsDrop(null));
                  dispatch(setIsToken(null));
                  dispatch(setHasBudgetCurrentYear(null));
                }
              }}
              able
              noOptionsMessage={() => "Tiada pilihan"}
            />
          </Form.Group>

          {isSuperadmin && (
            <Form.Group className='mb-3'>
              <Form.Label>Projek Persekutuan</Form.Label>
              <Select
                placeholder=''
                className='react-select-container'
                classNamePrefix='react-select'
                options={[
                  {
                    label: "Ya",
                    value: true,
                  },
                  {
                    label: "Tidak",
                    value: false,
                  },
                ]}
                value={
                  JSON.parse(localStorage.getItem("federalProjects")) || {
                    label: "Tidak",
                    value: false,
                  }
                }
                onChange={(value) => handleSelectFederalProject(value)}
                noOptionsMessage={() => "Tiada pilihan"}
              />
            </Form.Group>
          )}

          <div className='d-flex flex-column gap-3'>
            <Button
              variant='primary'
              className='flex-fill'
              onClick={handleSearch}
            >
              Cari
            </Button>
            <Button
              variant='light'
              className='flex-fill'
              onClick={handleResetField}
            >
              Set Semula
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MoreSearchField;
